import React, { Component } from "react";
import logo from "./logo.svg";
import "./App.css";
import { connect } from "react-redux";
import { actions } from "../store/index";

import BasicLayout from "../layouts/basic-layout";

import PropTypes from "prop-types";
// import Header from './Header/header';


const ContextType = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  actions: PropTypes.object.isRequired,
  cookies: PropTypes.object.isRequired,
  nebPay: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  isLoading: state.Billboards.isLoading,
  title: state.mainState.title,
  state: state.Billboards.data.state,
  price: state.Billboards.data.rentPrice,
  bid: state.Billboards.data.bid,
  renter: state.Billboards.data.renter,
  currentUserKey: state.mainState.currentUserKey,
});
/*eslint-disable */
// @connect(mapStateToProps)
class App extends Component {
  PropTypes = {
    context: PropTypes.shape(ContextType).isRequired,
    title: PropTypes.string,
    title: PropTypes.string,
    currentUserKey: PropTypes.string,
    bid: PropTypes.object,
    state: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };

  hendlerClick = () => {
    const ttl = Math.random();
    actions.changeTitle(ttl);
  };
  render() {
    // const { title } = this.props;
    return (
      <div className="App">
        {/* <Header title={title} /> */}

        {/* {this.props.isLoading ? "" : <Buy state={this.props.state} />} */}

        

        {/* {this.props.isLoading ? (
          ""
        ) : (
          <Auction
            state={this.props.state}
            offer={
              this.props.bid && this.props.bid.value ? this.props.bid.value : 0
            }
            price={this.props.price}
            isBidder={
              this.props.bid && this.props.bid.bidder
                ? this.props.currentUserKey === this.props.bidder
                : false
            }
          />
        )} */}
        
      </div>
    );
  }
}

export default connect(mapStateToProps)((context, params) => (
  <BasicLayout>
    <App params={params} />
  </BasicLayout>
));

// export default App;
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/components/App.js